import type { Currency } from "./currency";

export function formatPrice(
  amount: number,
  currency: Currency | null | undefined,
  locale?: string
): string {
  const dp =
    typeof currency?.decimal_places === "number" ? currency.decimal_places : 2;
  const code = (currency?.code || "").trim();
  const symbolRaw = (currency?.symbol || "").trim();

  let currencyLabel = code || "IQD";
  if (locale === "ar" || locale === "ku") {
    currencyLabel = symbolRaw || code || "د.ع";
    if (code === "SYP") currencyLabel = "ل.س";
    if (code === "IQD" || !code) currencyLabel = "د.ع";
  }

  const value = Number.isFinite(amount) ? amount : 0;
  const formatted = value.toFixed(dp);
  return currencyLabel ? `${formatted} ${currencyLabel}` : formatted;
}
